"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgClipboardTextFilled(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("defs", null,
            React.createElement("style", null, '.clipboard-text_filled_svg__cls-1{display:none}')),
        React.createElement("g", { id: "clipboard-text_filled_svg__transparent_box" },
            React.createElement("path", { className: "clipboard-text_filled_svg__cls-1", d: "M0 0h32v32H0z" }),
            React.createElement("path", { className: "clipboard-text_filled_svg__cls-1", d: "M0 0h32v32H0z" })),
        React.createElement("g", { id: "clipboard-text_filled_svg__FILLED" },
            React.createElement("path", { d: "M26 5h-4v4H10V5H6v25h20zm-9 18h-6v-2h6zm4-5H11v-2h10z" }),
            React.createElement("path", { d: "M20 4.18a2.76 2.76 0 00-.62-2.1A4.45 4.45 0 0016 1a4.48 4.48 0 00-3.39 1.08 2.76 2.76 0 00-.61 2.1V7h8z" }))));
}
exports.default = SvgClipboardTextFilled;
//# sourceMappingURL=ClipboardTextFilled.js.map